import { format, parse } from "date-fns";
import React from "react";
import { FaPlay } from "react-icons/fa6";
import { IoIosPause } from "react-icons/io";

const TaskSchedualsComp = ({ taskData }) => {

  const getDisplayTime = (scheduleTime) => {
    if (!scheduleTime) return "";

    let parsedDate;

    try {
      if (typeof scheduleTime === "string") {
        if (/^\d{2}:\d{2}$/.test(scheduleTime)) {
          // Only HH:mm provided → attach today's date
          const today = new Date();
          const composite = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')} ${scheduleTime}`;
          parsedDate = parse(composite, "yyyy-MM-dd HH:mm", new Date());
        } else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(scheduleTime)) {
          // Full YYYY-MM-DD HH:mm
          parsedDate = parse(scheduleTime, "yyyy-MM-dd HH:mm", new Date());
        } else {
          parsedDate = new Date(scheduleTime); // last resort
        }
      } else if (scheduleTime instanceof Date && !isNaN(scheduleTime.getTime())) {
        parsedDate = scheduleTime;
      }

      if (parsedDate && !isNaN(parsedDate.getTime())) {
        return format(parsedDate, "h:mma");
      }
    } catch (err) {
      console.warn("Failed to parse scheduleTime:", scheduleTime, err);
    }

    return ""; // fallback if invalid
  };

  const displayTime = getDisplayTime(taskData?.scheduleTime);

  if (!displayTime) return null; // don’t render invalid times

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        fontFamily: "Inter",
        fontSize: "10px",
        gap: "2px",
        color: "#757575",
      }}
      className="schedual_task_div"
    >
      <div>
        {taskData?.repeat !== 'none' && (
          taskData.active ? (
            <div style={{ background: '#CFF7D3', color: '#257048', border: "1px solid #257048", borderRadius: '50%', padding: '5px' }}>
              <FaPlay fontSize={12} />
            </div>
          ) : (
            <div style={{ background: '#FDF1C2', color: '#D08F36', border: '1px solid #D08F36', borderRadius: '50%', padding: '5px' }}>
              <IoIosPause fontSize={12} />
            </div>
          )
        )}
      </div>
      {taskData?.repeat !== 'none' && (
        <>
          <span style={{ textTransform: "capitalize", marginLeft: "3px" }}>{taskData?.repeat}</span>
          <span>at</span>
          <span>{displayTime}</span>
        </>
      )}
    </div>
  );
};

export default TaskSchedualsComp;
